import styles from "./styles.module.scss";
import { _ } from "i18n";
import { Zap } from "lucide-react";

export const AIEarlyAccessTag = () => {
	return (
		<div className={styles["tag"]}>
			<Zap size={14} className={styles["tag__icon"]} />
			<p className={styles["tag__text"]}>{_("ai.badge.early-access")}</p>
		</div>
	);
};
